export const version_app = "25.6.27";

export function detectDeviceType() {
  const userAgent = window.navigator.userAgent;
  if (/Android/i.test(userAgent)) {
    return 'Android';
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return 'iOS';
  } else {
    return 'Otro';
  }
}

export function emailValidator(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}

export const returnLowerCase = (text) => {
  return text.toLowerCase();
};

export const returnTextWithoutSpecialCharacters = (text) => {
  return text.replace(/\(/g, "").replace(/\)/g, "");
};

export const replaceSpacesWithUnderscores = (text) => {
  return text.replace(/ /g, "_");
};